import { useEffect, useState } from 'react';
import { Flex } from 'antd';

import { useAppSelector, useStatusFinderByNum } from '@Hooks/index';
import {
  useGetResignationRequestFormQuery,
  useGetSettlementAmountMutation,
} from '@Features/EmployeeSelfService/requests/ResignationRequests/store/api/resignationRequestApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { Status } from '@Components/Base';
import { getReasonOptions } from '@Features/EmployeeSelfService/requests/ResignationRequests/store/selectors/resignationRequestSelector';

import fieldSource from './FieldSource';
import styles from './view-form.module.css';

const ResignationRequestViewForm: React.FC = () => {
  const requestId = useAppSelector(getModalRecordKey);
  const reasonOptions = useAppSelector(getReasonOptions);

  const [settlementAmount, setSettlementAmount] = useState('');

  const { findStatus } = useStatusFinderByNum('Resignation');
  const { data } = useGetResignationRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });
  const [getSettlementAmount] = useGetSettlementAmountMutation();

  useEffect(() => {
    if (!data) {
      return;
    }

    getSettlementAmount(data.resDate)
      .unwrap()
      .then((response) => {
        setSettlementAmount(String(response));
      })
      .catch(() => {
        setSettlementAmount('');
      });
  }, [data]);

  if (!data) return null;

  return (
    <Flex className={styles.viewForm} vertical>
      {fieldSource(data, reasonOptions, settlementAmount).map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          {item.label === 'Status' ? (
            <Status
              className={styles.viewItemValue}
              text={findStatus(Number(item.value))?.codeDesc || ''}
            />
          ) : (
            <span className={styles.viewItemValue}>{item.value}</span>
          )}
        </div>
      ))}
    </Flex>
  );
};

export default ResignationRequestViewForm;
